import {
  EKwikUIToasterPosition,
  EKwikUIToasterShape,
  EKwikUIToasterSize,
  EKwikUIToasterType
} from "./toaster.definitions";

export const DEFAULT_VALUES = {
  id: "kwikui-toaster",
  duration: 5000,
  message: "",
  position: EKwikUIToasterPosition.TOP_RIGHT,
  shape: EKwikUIToasterShape.ROUNDED,
  size: EKwikUIToasterSize.M,
  type: EKwikUIToasterType.INFO,
  offset: { x: 0, y: 0 }
};

export const VALIDATE_KEY_VALUES = {
  duration: true,
  message: true,
  position: true,
  shape: true,
  size: true,
  type: true,
  offset: false
};
